﻿import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MessageService } from 'src/app/core/services/message.service';

@Component({
    selector: 'dialog-position-ship',
    templateUrl: './dialog-position-ship.component.html',
    styleUrls: ['./dialog-position-ship.component.scss']
})

export class DialogPositionShipComponent {
    positions: number[] = [];
    selectedPosition: number;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<DialogPositionShipComponent>,
    private messageService: MessageService) {
        this.positions = data;
  }

  movePosition() {
    if(!this.selectedPosition){
        this.messageService.warning('Error', 'Debe seleccionar una posición.');
      return;
    }
    this.dialogRef.close(this.selectedPosition);
  }
}